import { IntegrationType } from './integration-type';
import { FormGroupValue } from '../../ui/gzForm/formGroup/types/form-group-value';
import { NsvaNetworkSensorView } from '../sensors/nsva/view/NsvaNetworkSensorView';
import { MobileSecuritySensorView } from '../sensors/mobileSecurity/view/MobileSecuritySensorView';
import { GCPSensorView } from '../sensors/gcp/view/GCPSensorView';
import { GoogleWorkspaceSensorView } from '../sensors/googleWorkspace/view/GoogleWorkspaceSensorView';
import { IntuneSensorView } from '../sensors/intune/view/IntuneSensorView';
import { AzureCWSensorView } from '../sensors/azureCW/view/AzureCWSensorView';
import { AzureADSensorView } from '../sensors/azureADAudit/view/AzureADSensorView';
import { AwsSensorView } from '../sensors/aws/view/AwsSensorView';
import { ADOnPremSensorView } from '../sensors/ad-onprem/view/ADOnPremSensorView';
import { CloudSecuritySensorView } from '../sensors/cloudSecurity/view/CloudSecuritySensorView';
import { AtlassianAuditView } from '../sensors/atlassian/atlassianAudit/view/AtlassianAuditView';

export interface IntegrationData {
  _id?: string;
  name: string;
  type: IntegrationType;
  sensors: Array<Object>;
  integrationSpecifics: FormGroupValue;
}

export const INTEGRATION_VIEW_BY_TYPE_MAP = {
  [IntegrationType.AD_ONPREM]: ADOnPremSensorView,
  [IntegrationType.AWS]: AwsSensorView,
  [IntegrationType.AZURE_AD]: AzureADSensorView,
  [IntegrationType.AZURE_CW]: AzureCWSensorView,
  [IntegrationType.NSVA]: NsvaNetworkSensorView,
  [IntegrationType.INTUNE]: IntuneSensorView,
  [IntegrationType.GOOGLE_WS]: GoogleWorkspaceSensorView,
  [IntegrationType.GCP]: GCPSensorView,
  [IntegrationType.MOBILE_SECURITY]: MobileSecuritySensorView,
  [IntegrationType.CLOUD_SECURITY]: CloudSecuritySensorView,
  [IntegrationType.ATLASSIAN_CLOUD]: AtlassianAuditView,
};
